import React, { useEffect, useState } from "react";

import { useRouteData } from "react-static";
import { Link } from "@reach/router";

import { CollectableLang, LocationLink } from "@utils/data";
import useBodyClass from "@utils/useBodyClass";
import { useCurrentSettings } from "../PersistedData/settingsSlice";
import { CollectableViewProps } from "./index.interface";
import { absUrl, getMediaUrl, isBrowser, useCollect, usePrevLink, useUrl } from "../../utils/navigation";
import { useI18n } from "../../I18nextProvider";
import { useAccessibility } from "../Accessibility";

/* eslint jsx-a11y/media-has-caption: "off" */
/* eslint jsx-a11y/no-noninteractive-tabindex: "off" */

function CollectableView({ collectable }: CollectableViewProps) {
  const { modelSrc, modelScale } = collectable;
  const place: LocationLink = { ...collectable.next, type: "place" };
  const { lang } = useRouteData();
  const collectableListUrl = useUrl({ type: "collectable" });
  const isFromCollectableList = isBrowser ? absUrl(document.referrer) === absUrl(collectableListUrl) : false;
  const prevLink = usePrevLink(isFromCollectableList ? { type: "collectable" } : place);
  const colLang: CollectableLang = collectable[lang];
  const i18n = useI18n();
  const settings = useCurrentSettings();
  const fullModelSrc = getMediaUrl(modelSrc, "model");
  const collectSelf = useCollect({
    type: "collectable",
    id: collectable.id
  });
  const access = useAccessibility({
    full: [
      () => import("../Object3DViewer"),
      // Key prevent react from trying to keep this components between navigations
      {
        modelSrc: fullModelSrc,
        modelScale,
        alt: i18n.t("collectable.viewer", { name: colLang.title })
      }
    ],
    noscript: (
      <img
        src={getMediaUrl(collectable.imageSrc, "collectableAlt")}
        alt={i18n.t("collectable.image", { name: colLang.title })}
      />
    )
  });
  useEffect(() => {
    collectSelf();
  }, [collectSelf]);
  const classTypeModel = settings.mode === "full" ? "full3d" : "images";

  const viewTextarea = false;
  const isPage = collectable.type && collectable.type === "page";
  const pageClass = isPage ? "page" : "";
  if (isPage) {
    useBodyClass("page", "");
  }

  return (
    <main className={`collectable ${pageClass}`}>
      <div className="row">
        <Link
          aria-label={i18n.t("global.retour")}
          className="fp-closing-btn fiche-top"
          to={prevLink.path}
          state={prevLink.state}
        >
          <span className="screen-reader-only">{i18n.t("global.retour")}</span>
        </Link>
        <div className="info">
          <Link
            aria-label={i18n.t("global.retour")}
            className="fp-closing-btn fiche"
            to={prevLink.path}
            state={prevLink.state}
          >
            <span className="screen-reader-only">{i18n.t("global.retour")}</span>
          </Link>

          <h1 id="maincontent" tabIndex={0} dangerouslySetInnerHTML={{ __html: colLang.title }} />

          <div tabIndex={0}>
            {collectable.wolastoqey && (
              <p className="mot_traduit">
                <strong>{i18n.t("collectable.wolastoqey")}</strong>
                {collectable.wolastoqey}
              </p>
            )}
            {collectable.mikmak && (
              <p className="mot_traduit">
                <strong>{i18n.t("collectable.mikmak")}</strong>
                {collectable.mikmak}
              </p>
            )}

            <div id="editor" className="contenuTexte" dangerouslySetInnerHTML={{ __html: colLang.description }} />

            {colLang.reference && colLang.reference !== "" && (
              <details className="references">
                <summary>{i18n.t("collectable.reference")}</summary>
                <div className="references-contenu" dangerouslySetInnerHTML={{ __html: colLang.reference }} />
              </details>
            )}
          </div>
        </div>
        <div className={`modele3D ${classTypeModel}`}>{access}</div>
      </div>
    </main>
  );
}

export default CollectableView;
